import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 2px;
`;

export const Count = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 1;
  span {
    display: block;
    margin-right: 5px;
  }
`;
